import React from 'react';

export default function SpinnerOverlay() {

    return (
        <>

            <div
                className="d-flex flex-column min-vh-100 min-vw-100"
                style={{ backgroundColor: '#f8f9fa' }}
            >
                <div className="d-flex flex-grow-1 justify-content-center align-items-center">
                    <div className="spinner-border" role="status" style={{ width: "3rem", height: "3rem" }}>
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>

        </>
    )
}
